var map = {
	"./DLI.JPEG": 4894,
	"./IMG_2300.jpg": 4970,
	"./IMG_2689.JPG": 6219,
	"./apa_sejtgyujtes.JPEG": 7849,
	"./art_cafe.JPEG": 4308,
	"./asztal.jpg": 8998,
	"./baratok.JPG": 774,
	"./biciklis.jpg": 8429,
	"./bled.jpg": 9026,
	"./bogi_szulinap.PNG": 9850,
	"./box_utan.JPG": 3938,
	"./boxban.JPG": 9480,
	"./covid.jpg": 620,
	"./csunya_pulcsis.jpg": 958,
	"./erkely_apa.JPEG": 6416,
	"./evfordulo.jpg": 2499,
	"./feheren.JPG": 509,
	"./fej_hamlas.jpg": 2803,
	"./friss.JPG": 8155,
	"./furdo.jpg": 9735,
	"./gomba.jpg": 4371,
	"./indulas_haza.jpg": 3054,
	"./injekcio.jpg": 4979,
	"./itthon.jpg": 5551,
	"./kanul.jpg": 5558,
	"./kanul_gyulladas.jpg": 4049,
	"./karacsony.jpg": 9184,
	"./karacsony_mi.jpg": 5523,
	"./kemo.jpg": 1431,
	"./kez_hamlas.jpg": 5200,
	"./kiutes.JPG": 7853,
	"./kopasz_ujra.JPEG": 9822,
	"./kopaszon.jpg": 8924,
	"./korhaz_pados.JPEG": 584,
	"./korhazi_toltodes.jpg": 2172,
	"./lelet.jpg": 7855,
	"./logo.png": 678,
	"./logo.svg": 576,
	"./me_augusztus.jpg": 8323,
	"./me_before.png": 4255,
	"./me_before1.png": 4902,
	"./meki.JPEG": 7909,
	"./mintavetel.JPEG": 7708,
	"./most.jpg": 9346,
	"./mutet_utan.JPG": 3900,
	"./noverem_korhaz.jpg": 3243,
	"./noverem_udvar.jpg": 4370,
	"./nyugagyban.JPEG": 3982,
	"./oxigen.JPG": 8214,
	"./picc-line.jpg": 5929,
	"./piros_fej.JPEG": 2682,
	"./reszkessetek_betorok.jpg": 1979,
	"./seta.jpg": 6710,
	"./split.jpg": 6267,
	"./szajpadlas.jpg": 404,
	"./szanko.jpg": 2023,
	"./szentendre.jpg": 213,
	"./szilveszter.jpg": 7402,
	"./tapszer.JPEG": 2134,
	"./telefonzsinor.jpg": 3473,
	"./tokos.JPEG": 4781,
	"./transzplant_konzultacio.JPG": 9661,
	"./transzplant_utan.JPG": 626,
	"./transzplantacio.jpg": 8060,
	"./ujra_korhaz.jpg": 9535,
	"./utolso_toltodes.jpg": 2430,
	"./vadasa.jpg": 9537,
	"./vitorlas.jpg": 2253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;